import styles from '@features/categories/components/CategoriesSeo/CategoriesSeo.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  content: string;
};
const CategoriesSeo = ({
  content
}: PropsType) => {
  const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'strong', 'ul', 'li', 'ol', 'a', 'b', 'br'];
  const CONFIG_SANITIZE = {
    allowedTags: tags,
    allowedAttributes: {
      ol: ['style'],
      a: ['href', 'target', 'rel']
    }
  };
  return <div sx={styles.mainContainer}>
      <div sx={styles.containerContent} dangerouslySetInnerHTML={sanitizeHtml(content, CONFIG_SANITIZE)} />
    </div>;
};
export default CategoriesSeo;